exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".show-img-modal-area {\n\tposition: relative;\n\tmin-height: 100px;\n}\n\n.show-img-modal-area .close {\n\tposition: absolute;\n\tright: 5px;\n\ttop: 5px;\n}\n\n.show-img-modal-area .close i {\n\tfont-size: 25px;\n}\n\n.show-img-modal-area .modal-action-area .upload-icon {\n\twidth: 30px;\n}\n\n.show-img-modal-area .modal-action-area .upload-title {\n\tmargin-left: 5px;\n}\n\n.show-img-modal-area .modal-body .progress {\n\tbackground: #aaa;\n    height: 5px;\n    margin: 30px 20px;\n}\n\n.show-img-modal-area .done-icon {\n\tmargin: 20px 0;\n}\n\n.show-img-modal-area .done-icon i {\n\tfont-size: 50px;\n}\n\n.show-img-modal-area .done-icon i.success {\n\tcolor: #007aff;\n}\n\n.show-img-modal-area .done-icon i.error {\n\tcolor: #ff0000;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/app/modals/show-img-modal/show-img-modal.component.css
// module id = ../../../../../src/app/modals/show-img-modal/show-img-modal.component.css
// module chunks = main